// components
import { Container, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import Page from 'src/components/molecules/page';
import { AutoMailSettingEditCreate } from 'src/components/organisms/auto-mail-setting/edit-create';

export const AutoMailSettingCreatePage: FC = () => {
  /* 定数宣言 */
  const title = '自動返信メール・新規';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <AutoMailSettingEditCreate />
      </Container>
    </Page>
  );
};
